import {Crop, UuidOptionColor, Use, ViewBy} from '@/domain/services/Clas';
import {capitalize} from '@/domain/useCases/capitalize';

export const getLegendByView = (
  crops: Array<Crop>,
  uses: Array<Use>,
  user: Array<UuidOptionColor>,
  viewBy: ViewBy,
): StyledItem[] => {

  if (viewBy === ViewBy.DEFAULT) {
    return [];
  }

  const dataMap = {
    crop: crops,
    use: uses,
    user: user,
  };

  const data = dataMap[viewBy] ?? [];

  return data.map(({name, color}) => (
    {
      name: capitalize(name),
      type: 'fill',
      paint: {
        color: `${color}66`,
        outlineColor: color,
        outlineWidth: 1.5
      },
    }
  ));
};

export type StyledItem = {
  name: string;
  type: 'fill';
  paint: {
    color: string;
    outlineColor: string;
    outlineWidth: number;
  };
};